<template>
  <ul class="cat-check" :class="{ 'cat-check--child': depth > 0 }">
    <li v-for="c in nodes" :key="c.id">
      <label class="cat-check__row">
        <input type="checkbox" :checked="value.includes(c.id)" @change="toggle(c.id)">
        <span>{{ c.name || c.title }}</span>
      </label>
      <CategoryChecklist v-if="c.children && c.children.length" :nodes="c.children" :value="value" :depth="depth + 1" @input="$emit('input', $event)" />
    </li>
  </ul>
</template>

<script>
/** WordPress-style nested category checkbox list. v-model = array of category ids. */
export default {
  name: 'CategoryChecklist',
  props: { nodes: { type: Array, default: () => [] }, value: { type: Array, default: () => [] }, depth: { type: Number, default: 0 } },
  methods: {
    toggle(id) { this.$emit('input', this.value.includes(id) ? this.value.filter((x) => x !== id) : this.value.concat([id])) },
  },
}
</script>

<style scoped>
.cat-check { list-style: none; margin: 0; padding: 0; }
.cat-check--child { padding-right: 18px; }
.cat-check__row { display: flex; align-items: center; gap: 8px; margin: 0; padding: 4px 0; font-weight: 400; cursor: pointer; }
.cat-check__row input { margin: 0; }
</style>
